var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showText)?_c('div',{staticClass:"marquee"},[_c('div',{staticClass:"bbox",attrs:{"id":"box_el"}},[_c('div',{staticClass:"content",class:{ move: _vm.move },attrs:{"id":"con_el"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }